import SyncAltIcon from '@mui/icons-material/SyncAlt';
import { Paper, Typography } from '@mui/material';
import { brandAlpha } from '../../../theme/brandTokens';

const CustomerImportMappingPair = ({
  sourceLabel,
  targetLabel,
  onClick,
}) => (
  <Paper
    elevation={0}
    sx={{
      width: '100%',
      height: '39px',
      mt: 1.75,
      mb: 0.25,
      p: 0,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      gap: 1.5,
      borderRadius: '12px',
      boxShadow: `0 2px 16px 0 ${brandAlpha('text', 0.08)}`,
      border: '1px solid #2e7d32',
      bgcolor: '#f5fef8',
      cursor: onClick ? 'pointer' : 'default',
    }}
    onClick={onClick}
  >
    <Typography
      sx={{
        flex: 1,
        minWidth: 0,
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.6,
        color: '#2e7d32',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'right',
        px: 1,
      }}
    >
      {sourceLabel}
    </Typography>
    <SyncAltIcon sx={{ color: '#2e7d32', fontSize: 18, mx: 0.25 }} />
    <Typography
      sx={{
        flex: 1,
        minWidth: 0,
        fontSize: '0.8125rem',
        fontWeight: 700,
        lineHeight: 1.6,
        color: '#2e7d32',
        overflow: 'hidden',
        textOverflow: 'ellipsis',
        whiteSpace: 'nowrap',
        textAlign: 'left',
        px: 1.25,
      }}
    >
      {targetLabel}
    </Typography>
  </Paper>
);

export default CustomerImportMappingPair;
